function SEFIntro({ Attendee, allSEFComplete }) {
  return (
    <div className="welcome-message">
      <h1 className={window.innerWidth <= 768 ? "mobile-heading" : ""}>
        Welcome {Attendee.BasicInfo?.First_Name} to the Parent/ Student Portal
      </h1>
      <p className={window.innerWidth <= 768 ? "mobile-paragraph" : ""}>
        InvestIN has a duty of care to safeguard and provide support for all
        students attending a summer experience.{" "}
        <b>
          Please read this page in full before beginning the enrolment form. It
          must be submitted at least 4 weeks before the student’s arrival date.
        </b>
        <br></br>
        <br></br>
        The student enrolment form must be completed by either the student’s
        parent(s) or their legal guardian(s) (with parental responsibility). A
        legal guardian is someone other than the child’s parents who has the
        <b> legal authority</b> to make decisions related to their care and
        wellbeing, on behalf of a child.
        <br></br>
        <br></br>
        The purpose of this form is for InvestIN to have a full understanding of
        each student and to cater to their needs as much as possible, we ask
        that you complete this form as accurately as possible. InvestIN will
        handle all information on this form with the utmost discretion and in
        accordance with our privacy policy, which you can{" "}
        <a href="https://investin.org/pages/privacy-policy" target="_blank">
          <strong>read here.</strong>
        </a>
        .<br></br>
        <br></br>
        We will review each enrolment form for approval. Please be aware that
        this document could be used to risk assess a student for the duration of
        their time with us. We may also contact you should there be any missing
        information, or if further insights are required ahead of the student’s
        planned arrival.
        <br></br>
        <br></br>
        To complete this form for the student, you will need the following
        documents:
        <div className="text-left">
          <br></br>• A copy of the student’s passport, in the form of a jpeg or
          png image file
          <br></br>• A photo of the student in the form of a jpeg or png image
          file. This must be a clear photo of the student’s face and should be
          taken within the last 6 months
          <br></br>• Medication information for the student (this includes daily
          prescribed medication and life-saving medication)
          <br></br>• A copy of the student’s Education Plan to support with SEN
          needs, if applicable.
        </div>
        <br></br>
        <br></br>
        <br></br>
        This form is separated into sections, please ensure you input student
        information in the correct section:
        <div className="text-left">
          <br></br>1. Student Basic Information
          <br></br>2. Contacts
          <br></br>3. Student General Information Including Emergency Contacts
          <br></br>4. VISA Status
          <br></br>5. Photos
          <br></br>6. Food Allergies & Dietary Information
          <br></br>7. Non-Food Allergy Information
          <br></br>8. Student’s physical health, including disabilities and
          access needs
          <br></br>9. Student’s mental health
          <br></br>10. Special Educational Needs (SEN)
          <br></br>11. Other Medications
          <br></br>12. Declarations
        </div>
        <br></br>
        <br></br>
        <p style={{ fontSize: "1.5rem" }}>
          Please ensure you complete all sections of the form. If you have any
          questions, please contact us at info@investin.org, or through your
          InvestIN contact.
          <br></br> <br></br>
          <strong>Your Programme: </strong>{" "}
          {Attendee.BasicInfo?.ProgrammeTitle
            ? Attendee.BasicInfo.ProgrammeTitle
            : ""}
          <br></br>
          <strong>Date of Programme: </strong>{" "}
          {Attendee.BasicInfo?.ProgrammeDate
            ? Attendee.BasicInfo.ProgrammeDate
            : ""}
          <br></br>
          <strong>Programme Variant: </strong>{" "}
          {Attendee.BasicInfo?.ProgrammeVarient
            ? Attendee.BasicInfo.ProgrammeVarient
            : ""}
        </p>
        <br></br>
        <br></br>
        <br></br>
        {allSEFComplete && (
          <div className="all-Complete">
            <strong>✅All Forms Complete !✅</strong>
            <br></br>
            If any of your information changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </div>
        )}
      </p>
    </div>
  );
}

export default SEFIntro;
